module.exports = __webpack_public_path__ + "img/logo-immib.79ac4a8f.svg";